import { SET_CATEGORY_DATA } from "../actions/action";

const initialState = {
    categoryData:[]
};

const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CATEGORY_DATA:
      return {
        ...state,
        categoryData: action.payload.categoryData
      };
    default:
      return state;
  }
};

export default categoryReducer;
